import { Component, Injectable } from '@angular/core';
import * as $ from 'jquery';
import { GoogleAnalyticsService } from "src/app/services/google-analytics.service";

@Component({
    selector: 'juridico-footer',
    templateUrl: "./footer.component.html",
    styleUrls: ['../juridico.component.css']
})
@Injectable()

export class JuridicoFooter {

  constructor(){

  }

  scrollTo(id){
    $("html body").animate({
      scrollTop: $(id).offset().top
    }, 500);
  }

  public sendEvent(category: string, action: string, label: string): void {
    const service: GoogleAnalyticsService = new GoogleAnalyticsService();
    service.sendEvent(category, action, label);
  }
}
